(function () {
  'use strict';

  angular.module('app').component('paymentProviderList', paymentProviderList());

  function paymentProviderList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        paymentMethods: '<',
        onShowItem: '&',
      },
      controller: PaymentProviderListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/payment-providers/payment-provider-list/payment-provider-list.component.html',
    };
  }

  PaymentProviderListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'SessionService',
    'moment',
    'PaymentProviderService',
  ];

  function PaymentProviderListComponent(
    config,
    UtilService,
    AbilityService,
    SessionService,
    moment,
    PaymentProviderService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canShow: AbilityService.can('show_paymentprovider_accountadmin'),
      canUpdate: AbilityService.can('update_paymentprovider_accountadmin'),
      canDestroy: AbilityService.can('destroy_paymentprovider_accountadmin'),
    };

    const apiUrl = 'payment_provider_reports';
    vm.urlXls = apiUrl + '/export_payments_provider_xls.xlsx';
    vm.urlPdf = apiUrl + '/export_payments_provider_pdf.pdf';
    vm.reportName = 'payments_provider_report';

    // private properties
    // -----------------------
    let userLanguageCode = SessionService.getUserLanguage().code;
    const dateDisplay = userLanguageCode !== 'es' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
    // const dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.$onInit = function () {
      setPaymentProviders(vm.items);

      setDefaultFilters();

      setDocumentDatePicker();
    };

    // public methods
    // -----------------------
    vm.fetchResult = function () {
      vm.loadingItems = true;
      PaymentProviderService.getPaymentProviders(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        setPaymentProviders(vm.items);

        vm.totalItems = vm.meta.totalItems;
        vm.loadingItems = false;
      });
    };

    vm.refresh = function () {
      vm.fetchResult();
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      vm.fetchResult();
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;

      vm.fetchResult();
    };

    vm.showItem = function (item, mode) {
      if (!vm.permissions.canShow) return;

      vm.onShowItem({ item: item, mode: mode });
    };

    vm.deleteItem = function (item) {
      if (!vm.permissions.canDestroy) return;

      PaymentProviderService.deletePaymentProvider(item, vm.fetchResult);
    };

    vm.clearDocumentDate = function () {
      vm.documentDatePicker = {
        startDate: '',
        endDate: '',
      };

      delete vm.filterCriteria.by_date_from;
      delete vm.filterCriteria.by_date_to;

      vm.UtilService.filterResult();
    };

    vm.clearSearch = function () {
      setDefaultFilters();

      vm.fetchResult();
    };

    // private methods
    // -----------------------
    function setPaymentProviders(items) {
      // items.map((item) => {
      items.forEach((item) => {
        item.date = moment(item.date).format(dateDisplay);
        item.provider_name = item.provider.name + ' ' + item.provider.last_name;
        item.payment_method = vm.paymentMethods.find(
          (paymentMethod) => paymentMethod.code === item.payment_method_code
        );
      });
    }

    function setDefaultFilters() {
      vm.documentDatePicker = {
        // startDate: '',
        // endDate: '',
        startDate: vm.UtilService.startOfMonth(),
        endDate: vm.UtilService.today(),
      };

      vm.filterCriteria = PaymentProviderService.getFilterCriteria();

      vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(
        vm.UtilService.startOfMonth()
      );

      vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.UtilService.today());
    }

    function setDocumentDatePicker() {
      let filterByDocumentDate = () => {
        vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(
          vm.documentDatePicker.startDate
        );

        vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.documentDatePicker.endDate);

        vm.UtilService.filterResult();
      };

      vm.documentDateOptions = vm.UtilService.datePickerOptions({
        filterBy: filterByDocumentDate,
        rangeOptions: config.DOCUMENT_DATE_OPTIONS,
        dateDisplay: dateDisplay,
        maxDate: moment(),
      });
    }
  }
})();
